import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ObjectivesSection from './components/ObjectivesSection';
import CoverageSection from './components/CoverageSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ObjectivesSection />
      <CoverageSection />
      <ContactSection />
    </div>
  );
}
